import { Component, EventEmitter, Host, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core';
import { WorkshopJobcardCreateCustomerComponent } from './workshop-jobcard-create-customer/workshop-jobcard-create-customer.component';
import { WorkshopJobcardEditCustomerComponent } from './workshop-jobcard-edit-customer/workshop-jobcard-edit-customer.component';
import { WorkshopJobcardSearchCustomerComponent } from './workshop-jobcard-search-customer/workshop-jobcard-search-customer.component';
import { WorkshopJobcardDeleteCustomerComponent } from './workshop-jobcard-delete-customer/workshop-jobcard-delete-customer.component';
import { WorkshopJobcardCustomerExistsComponent } from './workshop-jobcard-customer-exists/workshop-jobcard-customer-exists.component';
import { WorkshopJobcardAddBookingNotesComponent } from './workshop-jobcard-add-booking-notes/workshop-jobcard-add-booking-notes.component';
import { HelpersService } from 'src/app/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { WorkshopJobcardAccordionComponent } from '../workshop-jobcard-accordion/workshop-jobcard-accordion.component';


@Component({
  selector: 'app-workshop-jobcard-customer-details',
  templateUrl: './workshop-jobcard-customer-details.component.html',
  styleUrls: ['./workshop-jobcard-customer-details.component.scss']
})
export class WorkshopJobcardCustomerDetailsComponent {

  @Input() jobcard: any;
  @Input() groupBookings: boolean = false; // New input for group bookings
  @Output() jobcardChange = new EventEmitter<any>();

  constructor(
    private helpersService: HelpersService,
    private modalService: NgbModal,
    private translate: TranslateService,
    @Optional() @Host() private parentComponent: WorkshopJobcardAccordionComponent
  ) {

  }

  ngOnInit() {
    //this.customerExists({ID: 1, Name: 'John', Surname: 'Doe', Email: 'john.doe@hubtiger.com', PhoneNumber: '1234567890'}, {ID: 2, Name: 'Jane', Surname: 'Doe', Email: '', PhoneNumber: '0987654321'});
  }


  searchCustomer() {
    const modalRef = this.modalService.open(WorkshopJobcardSearchCustomerComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;

    modalRef.result.then(
      (result) => {

        if (result.action === 'edit') {
          this.updateCustomer(result.customer);
        } else if (result.action === 'create') {
          this.createCustomer(result.search, result.type);
        } else if (result.action === 'delete') {
          this.removeCustomer(result.customer);
        } else if (result.customer && result.customer.ID) {
          this.jobcard.customer = result.customer;
          this.jobcardChange.emit({ ...this.jobcard });

          if (this.parentComponent) {
            this.parentComponent.onAddClick('item-details', null);
          }
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  createCustomer(searchTerm: string = '', searchType: string = '') {
    const modalRef = this.modalService.open(WorkshopJobcardCreateCustomerComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.searchTerm = searchTerm;
    modalRef.componentInstance.searchType = searchType;

    modalRef.result.then(
      (result) => {
        if (result.action === 'customerExists') {
          this.customerExists(result.existingCustomer, result.newCustomer);
          return;
        }        
        if (this.parentComponent) {
            this.parentComponent.onAddClick('item-details', null);
        }
        this.jobcardChange.emit({ ...this.jobcard });
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  updateCustomer(customer: any) {
    const modalRef = this.modalService.open(WorkshopJobcardEditCustomerComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl' 
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.customer = customer;

    modalRef.result.then(
      (result) => {
        if (result.action === 'delete') {
          this.removeCustomer(result.customer);
          return;
        }
        if (result.customer && result.customer.ID) {
          this.jobcard.customer = result.customer;
          this.jobcardChange.emit({ ...this.jobcard });
          if (this.parentComponent && !this.jobcard.selectedItem?.id) {
            this.parentComponent.onAddClick('item-details', null);
          }
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  removeCustomer(customer: any) {
    const modalRef = this.modalService.open(WorkshopJobcardDeleteCustomerComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'md'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.customer = customer;

    modalRef.result.then(
      (result) => {
        console.log('Customer selected:', result);
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  customerExists(exitingCustomer: any, newCustomer: any) {
    const modalRef = this.modalService.open(WorkshopJobcardCustomerExistsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.existingCustomer = exitingCustomer;
    modalRef.componentInstance.newCustomer = newCustomer;

    modalRef.result.then(
      (result) => {
        if(result.action === 'edit') {
          this.updateCustomer(result.customer);
          return;
        }
        this.jobcardChange.emit({ ...this.jobcard });
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  clearCustomer() {
    this.jobcard.customer = null;
    this.jobcard.selectedItem = null; // Clear selected item when customer is cleared
    this.jobcardChange.emit({ ...this.jobcard });
  }

  // addBookingNotes(){
  //   const modalRef = this.modalService.open(WorkshopJobcardAddBookingNotesComponent, {
  //     backdrop: true,
  //     backdropClass: 'jobcard-modal-popup-backdrop',
  //     windowClass: 'jobcard-modal-popup-window',
  //     size: 'md'
  //   });

  //   modalRef.componentInstance.jobcard = this.jobcard;

  //   modalRef.result.then(
  //     (result) => {
        
  //     },
  //     (onrejected) => {
        
  //     },
  //   );
  // }

  // clearBookingNotes(){
  //   this.jobcard.clientNotes = '';
  //   this.jobcardChange.emit({ ...this.jobcard });
  // }

}
